/* Sable & Ochre - digital-download consent, progressive enhancement only.
 *
 * READ THIS BEFORE CHANGING ANYTHING HERE: the consent gate does NOT depend on
 * this file. The checkbox in cart-template.liquid is a native `required` input
 * inside a form that no longer carries `novalidate`, so the browser blocks
 * checkout on its own with JavaScript disabled, blocked or still loading. That
 * is deliberate - a legal gate that a failed script can open is not a gate.
 *
 * What this file adds on top:
 *   1. An exact consent timestamp for the audit trail. Without it the order's
 *      created_at still dates the consent to within seconds; this is precision,
 *      not the record itself.
 *   2. A readable inline error instead of the browser's tooltip, which on some
 *      mobile browsers is shown off-screen or not at all when the invalid
 *      control has been scrolled past.
 */
(function () {
  'use strict';

  var box = document.getElementById('hp-digital-consent');
  if (!box) return;                       /* no digital item in this cart */

  var wrap  = box.closest('[data-hp-consent]');
  var stamp = document.querySelector('[data-hp-consent-stamp]');
  var form  = box.form;
  if (!form) return;

  /* Stamp on the affirmative act itself, not on submit: the moment that matters
     legally is when the customer ticked, and a cart can sit for a while between
     ticking and paying. Cleared on untick so a stale timestamp can never travel
     with an unticked box. */
  function record() {
    if (!stamp) return;
    stamp.value = box.checked ? new Date().toISOString() : '';
  }
  box.addEventListener('change', function () {
    record();
    if (box.checked && wrap) { wrap.removeAttribute('data-hp-invalid'); }
  });
  record();

  /* The browser fires `invalid` on the control before it blocks the submit.
     Hooking that rather than the submit event means this stays correct however
     the form came to be submitted - button, Enter key, or anything else. */
  box.addEventListener('invalid', function (ev) {
    if (!wrap) return;
    /* Suppress the native bubble only because we are replacing it with
       something at least as visible, immediately below. */
    ev.preventDefault();
    wrap.setAttribute('data-hp-invalid', '');
    try {
      wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } catch (e) {
      wrap.scrollIntoView();
    }
    box.focus({ preventScroll: true });
  });
}());
